import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './fourteenthTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import { memo, useState } from 'react'
import CreateImageOptionModal from '../../CreateImageOptionModal'
import { IDraftImage, IImage, ITask } from '../../../../../types/tasks.types'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../sandbox.atom'
import { ReactComponent as RemoveIcon } from '../../../../../asserts/icons/xmark.svg'
import TextField from '../../../../../shared/Forms/TextField'
import Button from '../../../../../shared/Buttons/Button'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const FourteenthTypeTask = (props: IProps) => {
  const { draftTask } = useRecoilValue(sandboxAtom)

  const [open, setOpen] = useState(false)
  const [mainImageModalOpen, setMainImageModalOpen] = useState(false)

  const mainImageIndex = draftTask.images.findIndex((m) => m.isMain)
  const mainImage = draftTask.images[mainImageIndex]

  const renderOptions = () => {
    return (
      draftTask.images
        // @ts-ignore
        .filter((o) => !o.isMain)
        .map((option, index) => (
          <ImageOption option={option} key={option.id ?? index} index={index} onDelete={handleOptionDelete} />
        ))
    )
  }

  const handleOptionDelete = (index: number) => {
    props.onDraftTaskChange(
      [...draftTask.images.slice(0, index), ...draftTask.images.slice(index + 1)] as any,
      'images'
    )
  }

  const handleCreate = (option: IDraftImage) => {
    props.onDraftTaskChange([...(draftTask.images as IDraftImage[]), option], 'images')
    setOpen(false)
  }

  const handleMainCreate = (option: IDraftImage) => {
    props.onDraftTaskChange([...(draftTask.images as IDraftImage[]), { ...option, isMain: true }], 'images')
    setMainImageModalOpen(false)
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {open && <CreateImageOptionModal onClose={() => setOpen(false)} onCreate={handleCreate} />}
      {mainImageModalOpen && (
        <CreateImageOptionModal
          onClose={() => setMainImageModalOpen(false)}
          onCreate={handleMainCreate}
          isAnswer={false}
        />
      )}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.options}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={() => setOpen(true)}>
              Добавить карточку
            </div>
          </div>
          <div className={css.imageUpload}>
            <TextField header="Главное изображение">
              {!mainImage && <Button onClick={() => setMainImageModalOpen(true)}>Добавить</Button>}
              {mainImage && <ImageOption option={mainImage} index={mainImageIndex} onDelete={handleOptionDelete} />}
            </TextField>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

const ImageOption = memo(
  ({ option, index, onDelete }: { option: IDraftImage | IImage; onDelete: (index: number) => void; index: number }) => {
    let url
    if ('imageFile' in option) {
      url = URL.createObjectURL(option.imageFile)
    } else {
      url = option.file
    }

    return (
      <div
        className={css.imageOption}
        style={{ backgroundImage: `url(${url})` }}
        data-rightanswer={option.rightAnswer}
        key={url}
      >
        <RemoveIcon onClick={() => onDelete(index)} className={css.cancel} />
      </div>
    )
  }
)

export default FourteenthTypeTask
